import type { PropsWithChildren } from 'react';
import React, { useContext } from 'react';

import type { ContextualData } from '../contextualData';
import { emptyContextualData, mergeContextualData } from '../contextualData';

const ContextualDataContext = React.createContext<ContextualData>(emptyContextualData);

/** Gets current contextual data. */
export const useContextualData: () => ContextualData = () => {
  return useContext(ContextualDataContext);
};

/** Adds contextual data. The data will be appended to any parent data. */
export const AddContextualData: React.FC<PropsWithChildren<Partial<ContextualData>>> = ({
  children,
  user,
  data = {},
  campaignContext,
  customerContext,
  exclusiveOffersContext,
  leadContext,
  sellDirectContext,
}) => {
  const parent = useContextualData();
  return React.createElement(
    ContextualDataContext.Provider,
    {
      value: mergeContextualData(parent, {
        user,
        data,
        campaignContext,
        customerContext,
        exclusiveOffersContext,
        leadContext,
        sellDirectContext,
      }),
    },
    children,
  );
};
